import EventBus from './Event';

class SupportForm {
  constructor(el) {
    this.el = el;
    this.$el = $(el);

    this.bindEvents();

    window.grapp.instances = window.grapp.instances ? [...window.grapp.instances, this] : [this];
  }

  bindEvents() {
    EventBus.on('user:loaded', this.onUserLoaded.bind(this));
  }

  onUserLoaded() {
    const user = window.grapp.user;
    if (!user) {
      console.error('No user found');
      return;
    }

    this.$el.find('[name="support_owner_user"]').val(user.auth.email);
  }

  static init() {
    $('[data-js-component="support-form"]').each((i, el) => new SupportForm(el));
  }
}

SupportForm.init();
